/* eslint-disable @typescript-eslint/no-explicit-any */
"use client";

import { useEffect } from "react";
import { usePathname, useRouter } from "next/navigation";

const scrollMap: Record<string, number> = {};

const ScrollRestorer: React.FC = () => {
  const pathname = usePathname();
  const router = useRouter();

  // Save scroll position on route change
  useEffect(() => {
    const handleBeforeUnload = () => {
      scrollMap[pathname] = window.scrollY;
    };

    const handleRouteChangeStart = () => {
      scrollMap[pathname] = window.scrollY;
    };

    window.addEventListener("beforeunload", handleBeforeUnload);
    // Optional chaining in case `events` is undefined in some environments
    (router as any)?.events?.on?.("routeChangeStart", handleRouteChangeStart);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
      (router as any)?.events?.off?.(
        "routeChangeStart",
        handleRouteChangeStart
      );
    };
  }, [pathname, router]);

  // Restore scroll position on mount
  useEffect(() => {
    const scrollY = scrollMap[pathname] || 0;
    window.scrollTo(0, scrollY);
  }, [pathname]);

  return null;
};

export default ScrollRestorer;
